import { useMemo } from "react";

import useTypedContext from "hooks/useTypedContext";
import { CREATE_TEMPLATE_DEPLOYMENT_ACCESS_TYPES } from "shared/Templates/access/useCanCreateTemplateDeployment";
import { hasAtLeastOneRequiredAction } from "utils/access";
import { SpacesContext } from "views/Account/SpacesProvider";
import { AccountContext } from "views/AccountWrapper";
import { Action, Space } from "types/generated";

const UPDATE_TEMPLATE_DEPLOYMENT_ACCESS_TYPES = [
  Action.SpaceAdmin,
  Action.UpgradeBlueprintDeployment,
];

const useDeploymentAvailableSpaces = (isEditMode?: boolean): Space[] => {
  const { spaces } = useTypedContext(SpacesContext);
  const { viewer } = useTypedContext(AccountContext);
  const requiredActions = isEditMode
    ? UPDATE_TEMPLATE_DEPLOYMENT_ACCESS_TYPES
    : CREATE_TEMPLATE_DEPLOYMENT_ACCESS_TYPES;

  const availableSpaces = useMemo(() => {
    return spaces?.filter((space) =>
      hasAtLeastOneRequiredAction(requiredActions, viewer, space.id)
    );
  }, [spaces, viewer, requiredActions]);

  return availableSpaces || [];
};

export default useDeploymentAvailableSpaces;
